// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const initFacebook = () => {
  if (window.FB) {
    window.FB.init({
      appId: process.env.REACT_APP_META_APP_ID,
      cookie: true,
      xfbml: true,
      version: 'v17.0',
    })
  }
}

export const getFacebookToken = async (): Promise<string> => {
  initFacebook()
  return new Promise((resolve, reject) => {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          resolve(response.authResponse.accessToken)
        } else {
          reject('User cancelled login or did not fully authorize.')
        }
      },
      { scope: 'public_profile,email,ads_management,business_management', return_scopes: true }
    )
  })
}
